export default {
  bookExperiencePanel: "Panneau de réservation d'expérience",
  calendarIcon: 'Icône de calendrier',
  coverImageForResource: 'Image de couverture pour les expériences {{title}}',
  filterBy: 'Filtrer par {{filter}}',
  filterByDateRange: 'Filtrer par plage de dates',
  gallery: 'Galerie',
  goBack: 'Retour à la page précédente',
  hostUserIcon: "Icône d'utilisateur hôte",
  imageOf: 'Image de {{title}}',
  interactiveMapAltText: 'Carte interactive avec sélection de {{title}}',
  mediaSlides: 'Diapositives multimédia',
  muteVideo: 'Couper le son de la vidéo',
  nextPhoto: 'Photo suivante',
  noVideoPlayback: 'Aucune capacité de lecture vidéo',
  pauseVideo: 'Mettre la vidéo en pause',
  photoOf: 'Photo de {{name}}',
  playVideo: 'Lire la vidéo',
  previousPhoto: 'Photo précédente',
  moreFiltersAndExperiences: "Plus de filtres et d'expériences",
  reserveSelectedSlot: 'Réserver le créneau sélectionné',
  reviewRating: 'Note de l’avis {{rating}} sur 5',
  overallReviewRating: 'Note globale des avis {{rating}} sur 5',
  selectCountryCodeForPhoneNumber:
    'Sélectionner le code pays pour le numéro de téléphone',
  selectDate: 'Sélectionner la date',
  selectParticipants: 'Sélectionner les participants',
  selectSessionTime: "Sélectionner l'heure de la session",
  unmuteVideo: 'Rétablir le son de la vidéo',
  viewShoppingCart: 'Voir le panier',
  itemsInCart: '{{count}} articles dans le panier',
  zoomIn: 'Zoomer',
  zoomOut: 'Dézoomer',
  selectData: 'Sélectionner {{data}}',
  reserveName: 'Réserver {{name}}',
  increaseAddOnAmount: 'Augmenter {{addOn}} sélectionné',
  decreaseAddOnAmount: 'Diminuer {{addOn}} sélectionné',
  addOnModal: '{{addOn}} modal',
  moreInformationAboutAddOn: 'Plus d’informations sur {{addOn}}',
  decreasePriceTierTickets: 'Diminuer les billets {{priceTier}}',
  increasePriceTierTickets: 'Augmenter les billets {{priceTier}}',
  downloadFilename: 'Télécharger {{filename}}',
  viewFullDetailsDescription: 'Voir la description complète',
  viewFullDescription: 'Voir la description complète',
  closeModal: 'Fermer la fenêtre modale',
  hyattBanner: 'Bannière exclusive aux membres World of Hyatt',
  hyattBannerDesc:
    'Bannière promotionnelle indiquant les avantages et offres exclusifs disponibles pour les membres du programme de fidélité World of Hyatt',
  previousSlide: 'Slide précédent',
  nextSlide: 'Slide suivant',
  paginationBulletMessage: 'Aller au slide',
  exitFullscreen: 'Quitter le mode plein écran',
  enterFullscreen: 'Entrer en mode plein écran',
  videoSlide: 'Slide vidéo',
  imageSlide: 'Slide image',
  of: 'de',
  noDescription: 'Aucune description',
  mediaGallery: 'Carrousel - Galerie multimédia',
  dateSelector: 'Sélecteur de date',
  nextWeek: 'Semaine suivante',
  previousWeek: 'Semaine précédente',
  scheduleAgenda: 'Agenda du calendrier',
  scheduleNav: 'Navigation du calendrier',
  scheduleViewSelector: 'Sélecteur de vue du calendrier',
  selectedDateAriaLabel: '{{date}}, sélectionné',
  tapToBookExperience: 'Réserver {{title}}',
  bookExperienceAriaLabel: 'Réserver {{title}}',
  joinWaitlistAriaLabel: "Rejoindre la liste d'attente pour {{title}}",
};
